/* eslint-disable */ // TODO: fix lint errors and remove this comment
import {
  AlertFieldByType,
  AlertFooter,
  NotifyViaPills,
  TriggerTypeCard,
  AlertRecipientSelector,
} from './components';
import { useState, useEffect, useRef } from 'react';
import { Flex, Divider, Form, message } from 'antd';
import {
  GxPReportEventOptions,
  notificationsTriggerType,
} from '../../../common/static_data';
import {
  createShipmentNotification,
  updateShipmentNotification,
} from '@/apis/shipment';
import dayjs from 'dayjs';
import { useFetchAlertThresholds } from '@/hooks';
import NotificationFrequency from './components/NotificationFrequency';
import useFetchShipmentTeams from '@/hooks/useFetchShipmentTeams';
import RecipientValidationField from './components/RecipientValidationField';

const ShipmentNotificationModal = ({
  step,
  setStep,
  selected,
  openNotificationModal,
  setOpenNotificationModal,
  unauthorize,
  shipment,
  checkTokenExpiry,
  loggedInUserId,
  recipientData,
  onSuccess,
  shipmentId,
  isMultiple = false,
  onNotificationCreated,
  bulkScope,
}) => {
  const [selectedThresholdValues, setSelectedThresholdValues] = useState({});
  const [form] = Form.useForm();
  const [teams, setTeams] = useState([]);
  const [isRecipientsDropdownOpen, setIsRecipientsDropdownOpen] =
    useState(false);
  const [selectedTeams, setSelectedTeams] = useState('');
  const [alertType, setAlertType] = useState(notificationsTriggerType?.[0].id);
  const [selectAllAlertTypes, setSelectAllAlertTypes] = useState(false);
  const [notificationMethod, setNotificationMethod] = useState('');
  const [selectedFrequency, setSelectedFrequency] = useState('REALTIME');
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [additional, setAdditional] = useState([]);
  const [recipientsValues, setRecipientsValues] = useState([]);
  const [selectedFrequencyOption, setSelectedFrequencyOption] =
    useState('REALTIME');
  const initializedSelectedIdRef = useRef(null);
  const { alertThreshold, isLoading } = useFetchAlertThresholds(
    isMultiple ? null : selectedTeams
  );
  const allGxPReportEvents = GxPReportEventOptions.map((event) =>
    event.value.toLowerCase()
  );
  const normalizeGxPEvents = (events = []) =>
    (Array.isArray(events) ? events : []).map((event) =>
      typeof event === 'string' ? event.toLowerCase() : event
    );
  const normalizeGxPEventsForForm = (events = []) =>
    (Array.isArray(events) ? events : []).map((event) =>
      typeof event === 'string' ? event.toUpperCase() : event
    );
  let { shipmentTeams } = useFetchShipmentTeams(
    !isMultiple ? (shipmentId ? shipmentId : null) : null
  );
  shipmentTeams = shipmentTeams.filter(
    (x) => x.name.toLowerCase() !== 'default'
  );

  const handleTeamsData = (data) => {
    setTeams(data);
  };

  //this major useEffect is for patcing values , to the form
  useEffect(() => {
    if (!selected) {
      initializedSelectedIdRef.current = null;
      return;
    }
    const selectedKey = selected?.id;
    if (initializedSelectedIdRef.current === selectedKey) {
      return;
    }

    if (selected) {
      const normalizedLocation =
        selected?.location != null
          ? {
              value: selected.location,
              label: selected.location_name,
            }
          : null;
      form.setFieldsValue({
        location: normalizedLocation,
      });

      form.setFieldsValue({
        additional_recipients: selected?.additional_recipients,
        alert_type: selected?.alert_type,
        alert_types: selected?.alert_types,
        change_by: selected?.change_by,
        day: selected?.day,
        frequency: selected?.frequency,
        id: selected?.id,
        is_created: selected?.is_created,
        is_at_risk: selected?.is_at_risk,
        is_critical: selected?.is_critical,
        is_delivery_confirmation: selected?.is_delivery_confirmation,
        is_delivery_exception: selected?.is_delivery_exception,
        is_pickup_confirmation: selected?.is_pickup_confirmation,
        is_incomplete: selected?.is_incomplete,
        is_sent: selected?.is_sent,
        ai_action_type: selected.ai_action_type,
        team_id: selected.team_id,
        // location: selected?.location,
        message: selected?.message,
        notification_method: selected?.notification_method,
        scheduled_at: selected?.scheduled_at,
        send_to: selected?.send_to,
        sent_at: selected?.sent_at,
        teams: selected?.teams,
        time_1: selected?.time_1 ? dayjs(selected.time_1, 'h:mm a') : null,
        time_2: selected?.time_2 ? dayjs(selected.time_2, 'h:mm a') : null,
        users: selected?.users,
        gxp_report: normalizeGxPEventsForForm(selected?.gxp_report_events),
      });
      setAlertType(selected?.alert_type);
      setSelectAllAlertTypes(selected?.select_all_alert_types);
      setNotificationMethod(selected?.notification_method);
      if (selected?.alert_types) {
        setSelectedThresholdValues(selected?.alert_types);
        setStep(2);
      }
      let recepientsArr = [];
      let formValues = [];
      const teamsUsers = Array.isArray(selected?.send_to?.teams_users)
        ? selected?.send_to?.teams_users
        : [];
      teamsUsers.forEach((element) => {
        let obj = JSON.parse(JSON.stringify(element));
        if (obj) {
          const teamData = teams.find((t) => t.id === element?.id);
          if (element.select_all) {
            if (teamData) {
              teamData.select_all = true;
            }
            if (teamData?.users?.length > 0) {
              teamData.users.forEach((user) => {
                user.is_checked = true;
              });
            }
            let id = `${element.id}::ALL_MEMBERS`;
            recepientsArr.push(id);
            obj.users = [];
          } else {
            if (element?.users?.length > 0) {
              let userIds = [];
              element.users.forEach((user) => {
                let id = `${element.id}::${user?.id}`;
                if (teamData?.users?.length > 0) {
                  teamData.users.forEach((u) => {
                    if (u.id === user.id) {
                      u.is_checked = true;
                    }
                  });
                }
                userIds.push(user.id);
                recepientsArr.push(id);
              });
              obj.users = userIds;
            }
          }
          formValues.push(obj);
        }
      });
      const additionalKeys = (
        Array.isArray(selected?.send_to?.additional)
          ? selected.send_to.additional
          : []
      )
        .filter((a) => a.enabled !== false)
        .map((a) => a.key);

      let values = [...recepientsArr, ...additionalKeys];
      setSelectedRecipients(values);
      setAdditional(additionalKeys);
      setRecipientsValues(formValues);
      setSelectedFrequency(selected?.frequency || 'REALTIME');
      setSelectedFrequencyOption(
        selected?.frequency !== 'REALTIME' ? 'digest' : selected?.frequency
      );
      initializedSelectedIdRef.current = selectedKey;
    }
  }, [selected, teams]);

  const handleAlertType = (val) => {
    setAlertType(val);
    setNotificationMethod('');
    setSelectedThresholdValues({});
    setSelectAllAlertTypes(false);
    form.setFieldsValue({
      change_by: null,
      gxp_report: null,
      locations: null,
      is_pickup_confirmation: false,
      is_delivery_exception: false,
      is_delivery_confirmation: false,
      is_created: false,
      is_incomplete: false,
    });
  };

  const resetStates = () => {
    setNotificationMethod('');
    setSelectedThresholdValues({});
    setTeams([]);
    form.resetFields();
    setSelectedFrequencyOption('REALTIME');
    setSelectedFrequency('REALTIME');
  };

  useEffect(() => {
    if (openNotificationModal && !selected) {
      initializedSelectedIdRef.current = null;
      setAlertType(notificationsTriggerType?.[0].id);
      resetStates();
    }
  }, [openNotificationModal]);

  const handleResetOnNotificationMethodChange = (val) => {
    if (val) {
      //form.setFieldsValue({ users: null });
      setRecipientsValues([]);
      setAdditional([]);
      setSelectedRecipients([]);
      if (teams.length > 0) {
        teams.forEach((element) => {
          element.select_all = false;
          if (element?.users?.length > 0) {
            element.users.forEach((user) => {
              user.is_checked = false;
            });
          }
        });
      }
    }
  };

  const handleSubmit = (values) => {
    let keys = Object.keys(selectedThresholdValues ?? {});

    // const { additionalRecipientValues, sendToArray } = CreateSendToArray(
    //   values.users,
    //   teams
    // );
    const sendTo = recipientsValues;
    let model = values;
    delete model.users;
    model.location = values?.location?.value;
    model.alert_type = alertType;
    model.send_to = sendTo;
    model.alert_types = selectedThresholdValues;
    model.shipments = isMultiple ? shipmentId : [shipmentId];
    ((model.additional_recipients = additional),
      (model.frequency = selectedFrequency));
    model.select_all_alert_types = selectAllAlertTypes;
    model.time_1 = values?.time_1 ? values.time_1.format('h:mm a') : null;
    model.time_2 = values?.time_2 ? values.time_2.format('h:mm a') : null;
    if (alertType === 'TEMPERATURE_GXP') {
      const gxpReportEvents = normalizeGxPEvents(values?.gxp_report);
      model.gxp_report_events = gxpReportEvents;
      model.select_all_gxp_report_events =
        gxpReportEvents.length === allGxPReportEvents.length &&
        allGxPReportEvents.every((event) => gxpReportEvents.includes(event));
      delete model.gxp_report;
    }
    if (selected && selected?.id) {
      model.id = selected?.id;
    }
    if (!values?.team_id) {
      model.team_id = shipmentTeams[0]?.id || null;
    }
    if (
      alertType === 'CRITICAL_ALERT' &&
      (!selectedThresholdValues ||
        Object.keys(selectedThresholdValues).length === 0)
    ) {
      let allThresholds = {};
      alertThreshold?.forEach((element) => {
        element?.alerts.forEach((ele) => {
          const disable =
            ele?.sensor_required === 'required' &&
            !shipment?.sensor &&
            !isMultiple
              ? true
              : false;

          if (!disable) {
            allThresholds = {
              ...allThresholds,
              [ele.alert_type]: ele.threshold_value,
            };
          }
        });
      });
      model.alert_types = allThresholds;
      keys = Object.keys(allThresholds ?? {});
      model.select_all_alert_types = Object.keys(allThresholds)?.length > 0;
    }

    if (model?.team_id && Object.keys(model.alert_types).length > 0) {
      Object.keys(model.alert_types).forEach((key) => {
        let element = model.alert_types[key];

        alertThreshold.forEach((alertItem) => {
          const found = alertItem.alerts.find((x) => x.alert_type === key);
          if (found) {
            model.alert_types[key] = found.threshold_value;
          }
        });
      });
    }

    const isCritical = keys?.some((key) =>
      ['temperature_excursion_detected', 'viability_window_exhausted'].includes(
        key
      )
    );

    const isAtrisk =
      keys?.length > 0 &&
      !keys?.every((key) =>
        [
          'temperature_excursion_detected',
          'viability_window_exhausted',
        ].includes(key)
      );
    model.is_at_risk = isAtrisk;
    model.is_critical = isCritical;
    model.bulk = isMultiple;
    // calendar select-all: backend resolves shipments from scope, so no ids/bulk
    if (bulkScope) {
      delete model.shipments;
      delete model.bulk;
      Object.assign(model, bulkScope);
    }
    const token = checkTokenExpiry();

    const apiCall = selected?.id
      ? updateShipmentNotification(token, model, selected?.id)
      : createShipmentNotification(token, model);
    apiCall
      .then((res) => {
        const data = res?.data || {};
        if (data?.data?.is_success) {
          form.resetFields();
          message.success(data?.data?.message || 'Notification saved');
          if (!selected?.id && onNotificationCreated) {
            onNotificationCreated();
          }
        } else {
          message.error(data?.data?.message || 'Failed to save notification');
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        onSuccess();
      });
  };

  return (
    <Form form={form} onFinish={handleSubmit} layout='vertical'>
      <Flex vertical gap={16} style={{ margin: '20px 0px' }}>
        {step !== 3 && (
          <TriggerTypeCard
            setAlertType={handleAlertType}
            selected={selected}
            notificationsTriggerType={notificationsTriggerType}
          />
        )}
        <AlertFieldByType
          setSelectedTeams={setSelectedTeams}
          step={step}
          setStep={setStep}
          form={form}
          alertType={alertType}
          shipment={shipment}
          selectAllAlertTypes={selectAllAlertTypes}
          setSelectAllAlertTypes={setSelectAllAlertTypes}
          alertThreshold={alertThreshold}
          isLoading={isLoading}
          setSelectedThresholdValues={setSelectedThresholdValues}
          selectedThresholdValues={selectedThresholdValues}
          enableAllThresholds={isMultiple}
          shipmentTeams={shipmentTeams}
        />
        {step !== 3 && (
          <>
            <Divider className='notification-divider' />
            <NotifyViaPills
              form={form}
              notificationType='non-ai'
              notificationMethod={notificationMethod}
              setNotificationMethod={setNotificationMethod}
              resetOnChange={handleResetOnNotificationMethodChange}
              alertType={alertType}
            />
            <RecipientValidationField
              form={form}
              selectedRecipients={selectedRecipients}
            >
              <AlertRecipientSelector
                alertType={alertType}
                isRecipientsDropdownOpen={isRecipientsDropdownOpen}
                loggedInUserId={loggedInUserId}
                form={form}
                recipientData={recipientData}
                setIsRecipientsDropdownOpen={setIsRecipientsDropdownOpen}
                sendTeamsToParent={handleTeamsData}
                notificationMethod={notificationMethod}
                showAdditionalTP={false}
                selectedRecipients={selectedRecipients}
                setSelectedRecipients={setSelectedRecipients}
                setRecipientsValues={setRecipientsValues}
                setAdditional={setAdditional}
                recipientsValues={recipientsValues}
              />
            </RecipientValidationField>
            <NotificationFrequency
              form={form}
              selectedFrequencyOption={selectedFrequencyOption}
              setSelectedFrequencyOption={setSelectedFrequencyOption}
              selectedFrequency={selectedFrequency}
              setSelectedFrequency={setSelectedFrequency}
              notificationMethod={notificationMethod}
              isShipmentSpecific={true}
            />
          </>
        )}
      </Flex>
      <AlertFooter
        text={'Enable notifications'}
        step={step}
        setStep={setStep}
        setOpenNotificationModal={setOpenNotificationModal}
      />
    </Form>
  );
};
export default ShipmentNotificationModal;
